export default __webpack_public_path__ + "static/media/img3.8bc6cc29.png";